import React from 'react';
import { Node } from '@msdyn365-commerce-modules/utilities';
import {
    IBuyboxFindInStoreViewProps
} from '@msdyn365-commerce-modules/buybox';

export const BuyboxFindInStore = (props: IBuyboxFindInStoreViewProps): JSX.Element => {
    const {
        ContainerProps,
        storeSelector,
        heading,
        description,
        errors,
        button,
        modal,
        productPickupOptionList
    } = props;

    return (
        <Node {...ContainerProps}>
            {storeSelector}
            {heading}
            {productPickupOptionList}
            {description}
            {errors}
            {button}
            {modal}
        </Node>
    );
};